export default "__VITE_ASSET__CciNAEsG__"